<script>
export default {
    name: 'IconDone'
}
</script>
<template>
    <svg
        class="base-icon icon-done"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M51.765 15L56 19.235 30.527 44.704l.061.061L26.353 49 8 30.649l4.235-4.235L26.292 40.47 51.765 15z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
